import { FC, memo, PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useLearnWizard } from "src/hook/components/useLearnWizard";
import useTimeTracking from "src/hook/global/useTimeTracking";
import { useToast } from "src/hook/global/useToasts";
import { useComponentModal } from "src/hook/modal/useComponentModal";
import { useIFrameModal } from "src/hook/modal/useIFrameModal";
import usePopUp from "src/hook/modal/usePopUp";
import useUser from '../../hook/data/useUser';
import LearnWizard from '../Learn/LearnWizard/LearnWizard';
import ComponentModal from '../ui/Features/ComponentModal/ComponentModal';
import IFrameModal from '../ui/Features/IFrameModal/IFrameModal';
import PopUp from "../ui/Features/PopUp/PopUp";
import ToastContainer from '../ui/Features/Toast/ToastContainer';
import GuideModalHost from "../ui/GlobalComponents/Guides/GuideModalHost";
import { PageHeader } from '../ui/GlobalComponents/PageHeader/PageHeader';
import Main from './Main/Main';
import { useGuides } from "src/hook/components/useGuides";

const PagesHeader = ['/search', '/learn', '/lessons', '/wordlists', '/progress', '/scenario'];

const Layout: FC<PropsWithChildren> = ({ children }) => {
    const { isAuthenticated } = useUser();
    const location = useLocation();
    const [showHeader, setShowHeader] = useState(false);
    const { isOpen: isOpenIFrameModal } = useIFrameModal();
    const { toasts } = useToast();
    const { isOpen: isOpenComponentModal } = useComponentModal();
    const { isOpen: isOpenLearnWizard } = useLearnWizard();
    const { isOpen: isOpenPopUp } = usePopUp();
    const { visibleGuide } = useGuides();

    useTimeTracking();

    useEffect(() => {
        const showHeader = PagesHeader.includes(location.pathname);
        setShowHeader(showHeader);
    }, [location.pathname, isAuthenticated]);

    return (
        <>
            {isAuthenticated() ? (
                <article className={`fullPage`}>
                    {showHeader &&
                        <PageHeader />}
                    <Main showHeader={showHeader}>
                        {children}
                    </Main>
                    {/* <Footer /> */}
                </article >
            ) : (
                children
            )}

            {isOpenIFrameModal && <IFrameModal />}
            {isOpenComponentModal && <ComponentModal />}
            {toasts.length > 0 && <ToastContainer />}
            {isOpenLearnWizard && <LearnWizard />}
            {isOpenPopUp && <PopUp />}
            {visibleGuide && <GuideModalHost />}
        </>
    );
}

export default memo(Layout);